<template>
	<div class="knd-pijl-tekst" v-html="tekst" :style='{ color: "#" + kleur }'></div>
	<div class='knd-pijl animate-bounce'>
		<svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path :fill="'#' + kleur" d="M31.7692 44.0488L31.7692 20L35.2308 20L35.2308 44.0488C36.0615 41.9268 37.4462 40.0642 39.3846 38.461C41.3231 36.8577 43.8615 35.8911 47 35.561L47 39.0976C44.0923 39.4276 41.6 40.5594 39.5231 42.4927C37.4462 44.4732 36.0154 46.6423 35.2308 49L31.7692 49C30.9846 46.6423 29.5538 44.4732 27.4769 42.4927C25.4 40.5593 22.9077 39.4276 20 39.0976L20 35.561C23.1385 35.8911 25.6769 36.8577 27.6154 38.461C29.5538 40.0642 30.9385 41.9268 31.7692 44.0488Z"/>
		</svg>
	</div>
</template>

<script>
	import './pijl.scss';

	export default {
		name: 'Pijl',
		props: ['kleur', 'tekst']
	}
</script>